import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemeService } from '../services/theme';

@Component({
  selector: 'app-v2-disclaimer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './v2-disclaimer.html',
  styleUrls: ['./v2-disclaimer.scss'],
})
export class V2Disclaimer {
  protected readonly themeService = inject(ThemeService);
}
